const textEncoder = new TextEncoder()

export default textEncoder
